import React, {Component} from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';
import PropTypes from 'prop-types';

import Select from 'react-select';

import {MDBSelect} from 'mdbreact'

class DropdownUsers extends Component {

  state = {
  };

  componentWillReceiveProps= (nextProps) => {
    var opt =[]
      try {
        nextProps.options.forEach((item) => {
          
            opt.push({'text': item.firstname+' '+item.lastname, 'value': item.userId, 'checked':false});
         
         
        })
      } catch (error) {
        
      
      }
     if(nextProps.options!=this.props.options){
      this.setState({
        options: opt
       })
     }
    
    }
  onChange = (event) => {
    
  
    
    this.props.handlePick(event)
  }
 
  render() {
   
   const { classes, meta, registrationForm, input, label, options, linkedData } = this.props;

 // const dataToShow2 = linkedData.length > 0 ? linkedData : data;
  
  
   return (
    <FormControl
      aria-describedby="name-error-text"
      style={{width:"100%", borderRadius:'0px',fontFamily: 'Roboto', fontSize:'14px', color: '#000', minHeight:'42px'}}
    >
      {}
      <MDBSelect
        search
        {...input}
          name={label}
          label={label}
          value={''}
          options={this.state.options}
          selected={''}
          getValue={this.onChange}
        />
      {/* <Select 
    {...input}
    name={label}
    options={opt}
    value={this.props.input.value || ''}
    onBlur={() => this.props.input.onBlur(this.props.input.value)}
    onChange={this.onChange.bind(this)}
    theme={theme => ({
      ...theme,
      borderRadius: 0,
      borderColor: '#9E9E9E',
      color: '#000',
      fontSize: '14px',
      fontFamily: 'Roboto-Bold',
      minHeight:'42px'
    })}
   /> */}
    </FormControl>
   );
  }
 }
 export default (DropdownUsers)

const styles = () => ({
  ...commonStyles,
});


